import * as type from '../../../actions/index.types';

export function CtrlCommunityManagementReducers(
    state = {
        loading: false,
        createLoading: false,
        detailsLoading: false,
        communityData: null,
        communityDetails: null,
        error: null,
    },
    action
) {
    switch (action.type) {

        /* =========================
           GET COMMUNITY LIST
        ========================= */
        case type.CTRL_COMMUNITY_LIST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case type.CTRL_COMMUNITY_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                communityData: action.payload,
            };

        case type.CTRL_COMMUNITY_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           GET COMMUNITY DETAILS
        ========================= */
        case type.CTRL_GET_COMMUNITY_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            };

        case type.CTRL_GET_COMMUNITY_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                error: null,
                communityDetails: action.payload,
            };

        case type.CTRL_GET_COMMUNITY_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           CREATE COMMUNITY
        ========================= */
        case type.CTRL_CREATE_COMMUNITY:
            return {
                ...state,
                createLoading: true,
                error: null,
            };

        case type.CTRL_CREATE_COMMUNITY_SUCCESS:
            return {
                ...state,
                createLoading: false,
                error: null,
            };

        case type.CTRL_CREATE_COMMUNITY_FAILURE:
            return {
                ...state,
                createLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           EDIT COMMUNITY
        ========================= */
        case type.CTRL_EDIT_COMMUNITY:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            };

        case type.CTRL_EDIT_COMMUNITY_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                error: null,
                communityDetails: action.payload,
            };

        case type.CTRL_EDIT_COMMUNITY_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                error: action?.message || 'Something went wrong.',
            };

        /* =========================
           DELETE COMMUNITY
        ========================= */
        case type.CTRL_DELETE_COMMUNITY:
            return {
                ...state,
                error: null,
            };

        case type.CTRL_DELETE_COMMUNITY_SUCCESS:
            return {
                ...state,
                error: null,
            };

        case type.CTRL_DELETE_COMMUNITY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
            };

        default:
            return state;
    }
}
